import { setLoanTerm } from '@/context/borrower';
import { store } from '@/context/store';
import { IParameter } from '@/utils/setParametersFromParams';

export function setInitialLoanTerm(
    partnerLoanTerm: number,
    parameterLoanTerm: IParameter
): void {
    const currentTerm = store.getState().borrowerReducer.loan.loanTerm;

    const parsedParameter = Number(parameterLoanTerm);

    // If URL parameter is valid, always use it (regardless of currentTerm)
    if (
        !isNaN(parsedParameter) &&
        parsedParameter > 0 &&
        parsedParameter <= 7
    ) {
        if (currentTerm !== parsedParameter) {
            store.dispatch(setLoanTerm(parsedParameter));
        }
        // Always return here to prevent using partner default when URL param exists
        return;
    }

    // Only use partner default if no valid URL parameter
    if (currentTerm !== partnerLoanTerm) {
        store.dispatch(setLoanTerm(partnerLoanTerm));
    }
}
